import React from 'react';

export const FacebookIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.8787 11.9989H13.4108V21H10.0393V11.9989H7.79126V8.89792L10.0393 8.89318L10.0346 7.0741C10.0346 4.53593 10.7217 3 13.7034 3H16.1891V6.10572H14.6345C13.4778 6.10572 13.4105 6.54388 13.4105 7.34269V8.89318H16.2087L15.8787 11.9989Z"
      fill="#444D55"
    />
  </svg>
);
